import axios from "../plugins/axios";

type FundingHistory = {
    year: string;
    investor: string;
    amount: string;
    id: number;
};
export default class AuthApi {

    login(data: { login: string, password: string }) {
        const formData = new FormData();
        formData.append("login", data.login);
        formData.append("password", data.password);

        this.setPopUpSession();

        return axios.post("/login", formData);
    }

    mentorLogin(data: { login: string, password: string }) {
        const formData = new FormData();
        formData.append("email", data.login);
        formData.append("password", data.password);

        return axios.post("/mentor/login", formData);
    }

    updateProfile(data: { name: string, company_name: string, username: string, position: string, professional_link: string, gender: string, designation: string, company_sector: string, description: string, photo: any, year_estbl: string, industry: Array<string>, province_id: string, beneficiaries_type: string, impact_measurement: string, funding_history: FundingHistory[], referral_source: string, other_hear?: string  }) {
        const formData = new FormData();

        formData.append("company_name", data.company_name)
        formData.append("name", data.name)
        formData.append("position", data.position);
        formData.append("professional_link", data.professional_link);
        formData.append("gender", data.gender);
        formData.append("designation", data.designation);
        formData.append("company_sector", data.company_sector);
        formData.append("username", data.username);
        formData.append("description", data.description);
        formData.append("year_estbl", data.year_estbl);
        formData.append("province_id", data.province_id);
        formData.append("referral_source", data.referral_source === 'Other (write your own)' ? (data.other_hear || '') : (data?.referral_source ?? ''));

        if (data.photo) {
            formData.append("photo", data.photo);
        }

        if (Array.isArray(data.industry)) {
            data.industry.forEach((item, index) => {
                formData.append(`industry[${index}]`, item);
            });
        }
        
        formData.append("beneficiaries_type", data?.beneficiaries_type ?? '');
        formData.append("impact_measurement", data?.impact_measurement ?? '');
        
        if (data.funding_history.length > 0) {
            data.funding_history.forEach((item, index) => {
                formData.append(`funding_history[${index}][year]`, item.year);
                formData.append(`funding_history[${index}][investor]`, item.investor);
                formData.append(`funding_history[${index}][amount]`, item.amount);
            });
        }else{
            formData.append('funding_history', '');
        }
        
        return axios.post("/profile", formData);
    }

    register(data: { name: string, company_name: string, email: string, password: string, password_confirmation: string, phone: string, country_code: string, username: string, position: string, professional_link: string, gender: string, designation: string, company_sector: string, description: string, program_interest: Array<string>, photo: any, year_estbl: string, industry: Array<string>, province_id: string, beneficiaries_type: string, impact_measurement: string, funding_history: FundingHistory[], referral_source: string, other_hear?: string }) {
        const formData = new FormData();

        formData.append("company_name", data.company_name)
        formData.append("position", data.position)
        formData.append("professional_link", data.professional_link)
        formData.append("gender", data.gender)
        formData.append("designation", data.designation)
        formData.append("company_sector", data.company_sector)
        formData.append("description", data.description)
        formData.append("year_estbl", data.year_estbl)
        
        data.industry.forEach((item, index) => {
            formData.append(`industry[${index}]`, item);
        });
        
        if (data?.program_interest?.length > 0) {
            data?.program_interest?.forEach((item, index) => {
                formData.append(`program_interest[${index}]`, item);
            });
        }
        formData.append("referral_source", data.referral_source === 'Other (write your own)' ? (data.other_hear || '') : data.referral_source);

        formData.append("name", data.name)
        formData.append("email", data.email);
        formData.append("password", data.password);
        formData.append("password_confirmation", data.password_confirmation);
        formData.append("phone", data.phone);
        formData.append("country_code", data.country_code);
        formData.append("username", data.username);
        formData.append("province_id", data.province_id);
        formData.append("beneficiaries_type", data.beneficiaries_type);
        formData.append("impact_measurement", data.impact_measurement);

        if (data.funding_history.length > 0) {
            data.funding_history.forEach((item, index) => {
                formData.append(`funding_history[${index}][year]`, item.year);
                formData.append(`funding_history[${index}][investor]`, item.investor);
                formData.append(`funding_history[${index}][amount]`, item.amount);
            });
        }else{
            formData.append('funding_history', '');
        }

        // Display the key/value pairs
        for (var pair of formData.entries()) {
            console.log(pair[0]+ ', ' + pair[1]); 
        }
    
        this.setPopUpSession();
        
        return axios.post("/register-profile", formData);
    }

    forgotPassword(data: { email: string }) {
        const formData = new FormData();
        formData.append("email", data.email);

        return axios.post("/forget-password", formData);
    }

    resetPassword(token: string, data: { password: string, password_confirmation: string }) {
        const formData = new FormData();
        formData.append("password", data.password);
        formData.append("password_confirmation", data.password_confirmation);

        return axios.post("/reset-password/" + token, formData);
    }


    verifyOtp(data: { otp: string }) {

        const formData = new FormData();
        formData.append("otp", data.otp);

        return axios.post("/otp-verification", formData)
    }

    resendOtp() {
        return axios.post("/resend-otp")
    }

    getProfile() {
        return axios.get("/profile")
    }

    getMentorProfile() {
        return axios.get("/mentor/profile")
    }

    logout(isMentor = false) {
        return axios.post(`${isMentor ? '/mentor' : ''}/logout`)
    }

    setPopUpSession(isRemove = false) {
        sessionStorage.setItem('popUpSession', 'true');
        
        if (isRemove) {
            sessionStorage.removeItem('popUpSession');
        }
    }
}
